import { useAuth } from "reactfire";

const CardForNewUser = () => {
  const auth = useAuth();
  const firstName = auth.currentUser?.displayName?.split(" ")[0] || "User";

  return (
    <div className="rounded-lg bg-white p-6 text-nightRider shadow">
      <h2 className="tracking-[-0.84px mb-2 w-full truncate text-left font-archivo text-[28px] leading-[130%] font-light whitespace-nowrap">
        You're in, {firstName}!
      </h2>

      <p className="text-start text-xl leading-[140%] font-light tracking-[-0.2px] not-italic">
        We’ve emailed you a link. Open it on your desktop to download
        Aftershoot.
      </p>
    </div>
  );
};

export default CardForNewUser;
